export default __webpack_public_path__ + "d07fe8a36c8078588a58707c5d88a1da.woff";